<template>
	<div>
		<h2 class="text-center">Récapitulatif</h2>

		<hr />

		<div>
			<h3>Entreprise</h3>

			<p>Forme juridique de l'entreprise : <b class="text-primary">{{ company.legalForm }}</b></p>
			<p>Nom : <b class="text-primary">{{ company.name }}</b></p>
			<p>Activité : <b class="text-primary">{{ company.activity }}</b></p>
			<p>Téléphone : <b class="text-primary">{{ company.phone }}</b></p>
			<p>Adresse mail : <b class="text-primary">{{ company.mailAddress }}</b></p>


			<p>Objet social : <b class="text-primary">{{ company.socialObject }}</b></p>

			<h4>Siège Social</h4>
			<p>Emplacement : <b class="text-primary">{{ company.headOffice.location }}</b></p>
			<p v-if="company.headOffice.location !== 'Domiciliation via Assistel'">Adresse : <b class="text-primary">{{ company.headOffice.address.place }}<span v-if="company.headOffice.address.place && company.headOffice.address.zipCode">,</span> {{ company.headOffice.address.zipCode }} {{ company.headOffice.address.city }}</b></p>
			<p v-else>Adresse : <b class="text-primary">{{ company.headOffice.address.name }}</b></p>

			<h4>Capital Social</h4>
			<p>Montant : <b class="text-primary">{{ company.shareCapital.amount }}</b> <span v-if="company.shareCapital.amount">€</span></p>
			<p>Type : <b class="text-primary">{{ company.shareCapital.type }}</b></p>
			<p>Dépot : <b class="text-primary">{{ company.shareCapital.deposit.location }}</b></p>

			<h4 v-if="company.shareCapital.deposit.location === 'Dans une banque'">Banque</h4>
			<h4 v-else>Étude notariale ou CDC</h4>

			<p>Nom : <b class="text-primary">{{ company.shareCapital.deposit.name }}</b></p>
			<p>Adresse : <b class="text-primary">{{ company.shareCapital.deposit.address.place }}<span v-if="company.shareCapital.deposit.address.place && company.shareCapital.deposit.address.zipCode">, </span>{{ company.shareCapital.deposit.address.zipCode }} {{ company.shareCapital.deposit.address.city }}</b></p>

			<h4>Exercice social</h4>
			<p>Date du premier exercice social : <b class="text-primary">{{ company.fiscalYear.dateOfFirst }}</b></p>
			<p>Date de clôture d'un exercice social normal : <b class="text-primary">{{ company.fiscalYear.closingDate }}</b></p>
			<p>Date de clôture du premier exercice social : <b class="text-primary">{{ company.fiscalYear.closingDateOfFirst }}</b></p>

			<h4 v-if="company.commercialDistinction.acronym.active || company.commercialDistinction.commercialName.active || company.commercialDistinction.sign.active">Distinction commerciale</h4>
			<p v-if="company.commercialDistinction.acronym.active">Sigle : <b class="text-primary">{{ company.commercialDistinction.acronym.text }}</b></p>
			<p v-if="company.commercialDistinction.commercialName.active">Nom commercial : <b class="text-primary">{{ company.commercialDistinction.commercialName.text }}</b></p>
			<p v-if="company.commercialDistinction.sign.active">Enseigne : <b class="text-primary">{{ company.commercialDistinction.sign.text }}</b></p>
		</div>

		<hr />

		<div class="mb-4">
			<h3>Personne à contacter pour les formalités</h3>

			<p>Nom : <b class="text-primary">{{ company.representative.name.firstName }} {{ company.representative.name.lastName }}</b></p>
			<p>Numéro de téléphone : <b class="text-primary">{{ company.representative.phone }}</b></p>
			<p>Adresse mail : <b class="text-primary">{{ company.representative.mailAddress }}</b></p>
		</div>

		<div class="mb-4">
			<div v-if="company.leaders.length > 1">
				<h3>Dirigeants</h3>

				<b-tabs justified>
					<b-tab v-for="(leader,index) in company.leaders" :key="index" :title="tabTitle(index)" class="pt-3">
						<div v-if="index === 5">
							L'entreprise comprend plus de 5 dirigeants
						</div>

						<div v-else>
							<LeaderSummary :leader = leader />
						</div>
					</b-tab>
				</b-tabs>
			</div>

			<div v-else>
				<h3 v-if="company.legalForm !== 'SAS' && company.legalForm !== 'SASU'">Dirigeant</h3>
				<h3 v-else>Président</h3>

				<LeaderSummary :leader = company.leaders[0] />
			</div>
		</div>

		<div v-if="company.generalManager.exists" class="mb-4">
			<h3>Directeur général</h3>
			<p>Personne : <b class="text-primary">{{ company.generalManager.type }}</b></p>

			<p>Genre : <b class="text-primary">{{ company.generalManager.sex }}</b></p>
			<p><span v-if="company.generalManager.sex === 'Masculin'">Nom : </span> <span v-else>Nom de naissance : </span> <b class="text-primary">{{ company.generalManager.name.firstName }} <span v-if="company.generalManager.sex === 'Masculin'">{{ company.generalManager.name.lastName }}</span> <span v-else>{{ company.generalManager.name.birthName }}</span></b></p>

			<div v-if="company.generalManager.type === 'Physique'">
				<p>Statut marital: <b class="text-primary">{{ company.generalManager.maritalStatus }}</b></p>
				<p v-if="company.generalManager.maritalStatus === 'Mariée' && company.generalManager.sex === 'Féminin'">Nom marital : <b class="text-primary">{{ company.generalManager.name.maritalName }}</b></p>
				<p>Né le : <b class="text-primary" v-if="company.generalManager.birth.day">{{ company.generalManager.birth.day }}</b> <span v-if="company.generalManager.birth.day && company.generalManager.birth.city">à</span> <b class="text-primary">{{ company.generalManager.birth.city }}</b> <b class="text-primary" v-if="company.generalManager.birth.city && company.generalManager.birth.zipCode"> ({{ company.generalManager.birth.zipCode }})</b> <span v-if="company.generalManager.birth.day && company.generalManager.birth.country">en</span> <b class="text-primary">{{ company.generalManager.birth.country }}</b></p>
				<p>Nationalité : <b class="text-primary">{{ company.generalManager.birth.nationality }}</b></p>
				<p>Adresse : <b class="text-primary">{{ company.generalManager.address.place }}<span v-if="company.generalManager.address.place && company.generalManager.address.zipCode">,</span> {{ company.generalManager.address.zipCode }} {{ company.generalManager.address.city }}</b></p>
			</div>

			<div v-else>
				<p>Nom de la société : <b class="text-primary">{{ company.generalManager.company.name }}</b></p>
				<p>Numéro RCS : <b class="text-primary">{{ company.generalManager.company.rcs }}</b></p>
				<p>Adresse du siège social : <b class="text-primary">{{ company.generalManager.company.headOffice.place }}<span v-if="company.generalManager.company.headOffice.place && company.generalManager.company.headOffice.zipCode">,</span> {{ company.generalManager.company.headOffice.zipCode }} {{ company.generalManager.company.headOffice.city }}</b></p>
				<p>Ville du Greffe : <b class="text-primary">{{ company.generalManager.company.headOffice.registry }}</b></p>
				<p>Capital social : <b class="text-primary">{{ company.generalManager.company.shareCapital }}</b></p>
				<p>Forme sociale : <b class="text-primary">{{ company.generalManager.company.socialForm }}</b></p>
			</div>
		</div>

		<div>
			<div v-if="company.associates.length > 1">
				<h3 v-if="company.legalForm !== 'SAS' && company.legalForm !== 'SASU'">Associés</h3>
				<h3 v-else>Actionnaires</h3>

				<b-tabs justified>
					<b-tab v-for="(associate,index) in company.associates" :key="index" :title="tabTitle(index)" class="pt-3">
						<div v-if="index === 5">
							L'entreprise comprend plus de 5 associés
						</div>

						<div v-else>
							<AssociateSummary :associate = associate />
						</div>
					</b-tab>
				</b-tabs>
			</div>

			<div v-else>
				<h3 v-if="company.legalForm !== 'SAS' && company.legalForm !== 'SASU'">Associé</h3>
				<h3 v-else>Actionnaire</h3>

				<AssociateSummary :associate = company.associates[0] />
			</div>
		</div>

		<hr />

		<h3>Options</h3>
		<div class="d-flex align-items-center pl-3 mb-2 border border-primary rounded bg-white" v-if="activePack(packs) != null">
			<img :src="activePack(packs).image.src" :alt="activePack(packs).image.alt" width="30" height="30" class="mr-3" />
			<p class="mt-3">{{ activePack(packs).text }}</p>
		</div>

		<div v-for="(activeOption, index) in activeOptions(options)" :key="index" class="d-flex align-items-center pl-3 mb-2 border border-primary rounded bg-white">
			<img :src="activeOption.image.src" :alt="activeOption.image.alt" width="30" height="30" class="mr-3" />
			<p class="mt-3">{{ activeOption.text }}</p>
		</div>

		<hr />

		<b-row class="mb-5">
			<b-col>
				<h3>Total</h3>
				<p v-if="price.withDomiciliation" class="text-muted">+ Domiciliation</p>
				<p class="text-muted">+ TVA</p>
				<p v-if="price.withDomiciliation" class="text-muted">+ Dépôt de garantie</p>
			</b-col>

			<b-col cols="auto">
				<p class="h3">{{ price.withOptions }}€ HT</p>
				<p v-if="price.withDomiciliation" class="text-muted">{{ priceWithDomiciliation() }}€ HT</p>
				<p class="text-muted">{{ priceWithTaxes() }}€ TTC</p>
				<p v-if="price.withDomiciliation" class="text-muted">{{ priceWithDomiciliationTaxesNWarrantyDeposit() }}€ TTC</p>
			</b-col>
		</b-row>

		<div>
			<p class="text-black-50">
				Système de paiement propulsé par Stripe, leader du marché selon Forrester Wave™, respectant les normes de certification les plus strictes afin d'assurer la sécurité des paiements.
			</p>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto">
					<img src="../../assets/images/icons/certifications/pci.svg" alt="PCI Certification" width="50" height="auto" />
				</b-col>

				<b-col>
					<p class="text-white">Certification PCI DSS de niveau 1</p>
				</b-col>
			</b-row>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto">
					<img src="../../assets/images/icons/certifications/europe.svg" alt="Etoiles Européennes" width="50" height="auto" />
				</b-col>

				<b-col>
					<p class="text-white">Conforme à la directive européenne DSP2 et à l'authentification forte du client</p>
				</b-col>
			</b-row>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto" class="text-white text-center">
					<img src="../../assets/images/icons/certifications/aicpa-soc.svg" alt="AICPA / SOC" width="50" height="auto">
				</b-col>


				<b-col>
					<p class="text-white">Rapports SSAE18/SOC 1 type 1 et 2 et SSAE18/SOC 2 type 1 et 2</p>
				</b-col>
			</b-row>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto" class="text-white text-center">
					<img src="../../assets/images/icons/certifications/world.svg" alt="Terre" width="50" height="auto">
				</b-col>


				<b-col>
					<p class="text-white">Licence AFSL en Australie, licence d'établissement de monnaie électronique en Europe et enregistrement comme entreprise de services monétaires (ESM) au Canada</p>
				</b-col>
			</b-row>

			<div class="d-flex justify-content-between align-items-center">
				<img src="../../assets/images/icons/payment_cards/visa.svg" alt="VISA" width="50" height="auto" />
				<img src="../../assets/images/icons/payment_cards/mastercard.svg" alt="Master Card" width="50" height="auto" />
				<img src="../../assets/images/icons/payment_cards/american-express.svg" alt="American Express" width="50" height="auto" />
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	import AssociateSummary from './AssociateSummary.vue';
	import LeaderSummary from './LeaderSummary.vue';

	export default {
		components: {
			AssociateSummary,
			LeaderSummary
		},
		props: {
			company: {
				type: Object
			},
			packs: {
				type: Array
			},
			options: {
				type: Array
			},
			price: {
				type: Object,
				required: true
			}
		},
		methods : {
			tabTitle(index) {
				if (index === 5) {
					return "+5";
				} else {
					index ++;
					const title = index.toString();
					return title;
				}
			},
			priceWithDomiciliation () {
				return this.price.withOptions + this.services.domiciliation.price.initial;
			},
			priceWithTaxes () {
				if (this.price.withDomiciliation) {
					return Math.round(this.price.withOptions + this.services.domiciliation.price.initial * (1 + 20 / 100));
				} else {
					return Math.round(this.price.withOptions * (1 + 20 / 100));
				}
			},
			priceWithDomiciliationTaxesNWarrantyDeposit () {
				return this.priceWithTaxes() + this.services.domiciliation.price.warrantyDeposit;
			},
			activePack(packs) {
				let activePack = null

				packs.forEach((pack) => {
					if (pack.active === true)  {
						activePack = pack;
					}
				});

				return activePack;
			},
			activeOptions(options) {
				let activeOptions = [];

				options.forEach((option) => {
					if (option.active === true)  {
						activeOptions.push(option);
					}
				});

				return activeOptions;
			}
		},
		computed: {
			...mapState(['services']),
		}
	}
</script>
